import { render } from "./Game.vue?vue&type=template&id=78266758&scoped=true&ts=true"
import script from "./Game.vue?vue&type=script&lang=ts"
export * from "./Game.vue?vue&type=script&lang=ts"

import "./Game.vue?vue&type=style&index=0&id=78266758&scoped=true&lang=scss"

import exportComponent from "/Users/danny/Projecten/monkeysee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78266758"]])

export default __exports__